import { AxiosUtil } from '../../utils/axios-util'
import {
  errorResponseNotification,
  successNotification,
} from '../notification-service'
import EventConstants from '../../constants/EventConstants'

export const getRollupAttributes = eventId => {
  const url = EventConstants.EVENT + eventId + '/rollupSummaryAttributes'

  return AxiosUtil.get(url).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}

export const getColorCoding = (userIds: string[], type: string) => {
  return AxiosUtil.get(
    `${EventConstants.USER_SETTING}getColorCoding?userIds=${userIds}&type=${type}`,
  )
    .then(res => {
      return {
        id: res.data[0]?.id ?? null,
        colorCodes: res.data[0]?.colorCodes ?? [],
      }
    })
    .catch(err => {
      errorResponseNotification(err)
      throw err
    })
}

export const saveColorCoding = colorCodeRequest => {
  return AxiosUtil.put(
    `${EventConstants.USER_SETTING}saveColorCoding`,
    colorCodeRequest,
  )
    .then(res => {
      successNotification('Conditions saved successfully')
      return res.data.id
    })
    .catch(err => {
      errorResponseNotification(err)
      throw err
    })
}
